export const copyToClipboard = (message: string, cb: Function = () => {}) => {
  navigator.clipboard.writeText(message).then(() => cb());
};
